module.exports = __webpack_public_path__ + "static/media/Illus-Bread_1@2x.8148a1f0.png";